import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { useParams } from 'react-router-dom';

import styles from "./chronicConditionOptions.module.css"
import ChronicConditionDropdown from "../../../../components/chronicConditionDropdown"
import { EditChronicConditionOption, DeleteChronicCondition } from "../../../admin/chronicOptionModals"


const ChronicConditionOptions = ({ conditionOptions }) => {
    const { id: location_id } = useParams();

    const [isChronicOptionModalOpen, setIsChronicOptionModalOpen] = useState(false);
    const [isDeleteChronicOptionModalOpen, setIsDeleteChronicOptionModalOpen] = useState(false);
    const [selectedCondition, setSelectedCondition] = useState({});

    // Chronic Condition modals functions
    const openChronicOptionModal = (condition) => {
        setSelectedCondition(condition)
        setIsChronicOptionModalOpen(true);
        document.body.style.overflow = "hidden";
    };
    const closeChronicOptionModal = () => {
        setIsChronicOptionModalOpen(false);
        document.body.style.overflow = "auto";
    };

    const openDeleteChronicOptionModal = (condition) => {
        setSelectedCondition(condition)
        setIsDeleteChronicOptionModalOpen(true);
        document.body.style.overflow = "hidden";
    };
    const closeDeleteChronicOptionModal = () => {
        setIsDeleteChronicOptionModalOpen(false);
        document.body.style.overflow = "auto";
    };

    const formatMarkdownData = (data) => {
        if (Array.isArray(data)) {
            return data.map(formatMarkdownData);
        } else if (typeof data === "object" && data !== null) {
            return Object.fromEntries(
                Object.entries(data).map(([key, value]) => {
                    if (typeof value === "string") {
                        return [key, value.includes("\n") ? value.split("\n").map(item => item.trim()) : [value.trim()]];
                    }
                    return [key, value];
                })
            );
        }
        return data;
    };

    return (
        <>
            {formatMarkdownData(conditionOptions).map((condition) => (
                <ChronicConditionDropdown
                    key={condition.id}
                    title={condition.name[0]}
                    bodyMaxHeight={"1000px"}
                    content={
                        <div className={styles.conditions_wrapper}>
                            <>
                                <div className={styles.icd_prognosis}>
                                    <div>
                                        <h5>ICD Code</h5>
                                        <p>{condition.icd_code[0]}</p>
                                    </div>
                                    <div className={styles.prognosis}>
                                        <h5>Prognosis</h5>
                                        <div className={styles.plans_wrapper}>
                                            {condition.prognosis?.map((prognosis, i) => (
                                                <div key={i} className={styles.plan}>
                                                    <div className={styles.numbered_content_wrapper}>
                                                        <span className={styles.numberLabel}>{i + 1}.</span>
                                                        <span>{prognosis}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <h5>Symptoms</h5>
                                    <div className={styles.plans_wrapper}>
                                        {condition.symptoms?.map((symptom, i) => (
                                            <div key={i} className={styles.plan}>
                                                <div className={styles.numbered_content_wrapper}>
                                                    <span className={styles.numberLabel}>{i + 1}.</span>
                                                    <span>{symptom}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div>
                                    <h5>Treatment Goals</h5>
                                    <div className={styles.plans_wrapper}>
                                        {condition.treatment_goals?.map((goal, i) => (
                                            <div key={i} className={styles.plan}>
                                                <div className={styles.numbered_content_wrapper}>
                                                    <span className={styles.numberLabel}>{i + 1}.</span>
                                                    <span>{goal}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div>
                                    <h5>Planned Interventions</h5>
                                    <div className={styles.plans_wrapper}>
                                        {condition.planned_interventions?.map((plan, i) => (
                                            <div key={i} className={styles.plan}>
                                                <div className={styles.numbered_content_wrapper}>
                                                    <span className={styles.numberLabel}>{i + 1}.</span>
                                                    <span>{plan}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        </div>
                    }
                    onEditClick={() => openChronicOptionModal(conditionOptions.find((con) => con.id === condition.id))}
                    onDeleteClick={() => openDeleteChronicOptionModal(conditionOptions.find((con) => con.id === condition.id))}
                />
            ))}

            {isChronicOptionModalOpen && (
                <EditChronicConditionOption
                    data={selectedCondition}
                    isOpen={isChronicOptionModalOpen}
                    onClose={closeChronicOptionModal}
                />
            )}

            {isDeleteChronicOptionModalOpen && (
                <DeleteChronicCondition
                    data={selectedCondition}
                    isOpen={isDeleteChronicOptionModalOpen}
                    onClose={closeDeleteChronicOptionModal}
                />
            )}
        </>
    )
}

export default ChronicConditionOptions